import Icon from 'veui/components/Icon'

Icon.register({
  'file-send': {
    paths: [
      {
        d: 'M544 224a32 32 0 00-32-32H256a32 32 0 000 64h256a32 32 0 0032-32zm-64 480a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32v256a32 32 0 01-64 0V96H160v576h288a32 32 0 0132 32zm-32-352a32 32 0 010 64H256a32 32 0 010-64zm278.63 73.37a32 32 0 00-33.87-7.37l-256 96a32 32 0 00-1.8 59.18l100.67 44.95 43 98.63A32 32 0 00608 736h.84A32 32 0 00638 715.24l96-256a32 32 0 00-7.37-33.87zM605.76 618.85l-16.43-37.65A32 32 0 00573 564.78l-40.77-18.2 117.05-43.9z'
      }
    ],
    width: '768',
    height: '768'
  }
})
